import { AiTwotonePhone } from 'react-icons/ai'; 
import { FaEnvelope } from 'react-icons/fa';
import { BsMapFill, BsClockFill } from 'react-icons/bs';

  
const contacts = [
    {
        id: 1,
        icon: <AiTwotonePhone />,
        title: 'Contacto',
        content: ['+xxx xxx xxx'],
    },
    {
        id: 2,
        icon: <BsClockFill />,
        title: 'Horario',
        content: ['Lunes a Viernes de: 8am a 6pm'],
    },
    {
        id: 4,
        icon: <BsMapFill />,
        title: 'Dirección',
        content: ['Osorno 651, Tierras Blancas, Coquimbo'],
    },
 
];

export default contacts;